import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Pipe, PipeTransform, ViewChild, Inject} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';

import {HttpClient} from "@angular/common/http";
import {APIConfigService} from "../../api.config.service"; import {AngularMaterial2Module} from "../../app.module.material";
import {RestServiceImpl} from "../immerdrin/rest.service.impl";
import {RestService} from "../immerdrin/rest.service.interface";
import {AuthService} from "../../shared/auth.service";
import {SessionService} from "../../shared/session.service";
import {LoggerService} from "../../shared/logger.service";
import {oase_config} from "../../../environments/environment";
import {BreadcrumbService} from "../../shared/breadcrumb/breadcrumb.service";
// import {CopyService} from "../../../shared/copy.service";
// import {DragulaService} from "ng2-dragula";
import {OaseDeleteDialogComponent} from "../immerdrin/oase.delete.component";
import {Tabelle} from "../immerdrin/tabelle/tabelle";
// import {Kerngruppe} from "./kerngruppe.model";
// import {Kernrecht} from "../kernrecht/kernrecht.model";
// import {KerngruppeInsertEditComponent} from "./kerngruppe.insertEdit.component";
import {FormControl} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {Subject} from "rxjs";
import {SelectFilterUtil} from "../immerdrin/select-filter.util";
import {FlexModule,MediaObserver} from "@ngbracket/ngx-layout";
import {LieferantenGruppe} from "../../shared/lieferantengruppe.model";
import {Frage} from "../fragebogen/frage.model";
import {KontaktInsertEditComponent} from "./kontakt.insertEdit.component";
import {Kontakt} from "./kontakt.model";
import {Fragebogen} from "../fragebogen/fragebogen.model";
import {Kategorie} from "../kategorie/kategorie.model";
import {ErrorHelper} from "../../shared/error.helper";

const PATH_FILE = 'app/protected/kontakt/kontakt.component.ts';
const OBJ_LNG_NAME = 'kontakt';
const BACKEND_PATH_PREFIX = 'kontakt';
// const REST_API_BASE =
// 	( window.location.hostname == 'localhost' ? oase_config.restapi.schema + '://' : '' ) + // z.B. http://
// 	( window.location.hostname == 'localhost' ? oase_config.restapi.host : '' ) + // z.B. masterproject.oase.at
// 	( window.location.hostname == 'localhost' ? ( oase_config.restapi.port ? ':' + oase_config.restapi.port : '' ) : '' ) + '/' + // z.B. :80/ oder /
// 	oase_config.restapi.path + '/'; // z.B. masterproject/
// const REST_API =
// 	REST_API_BASE +
// 	BACKEND_PATH_PREFIX; // z.B. tipp/
// const REST_API_KATEGORIE = REST_API_BASE + 'kategorie/';

@Component({
    selector: 'oase-kontakt',
    templateUrl: './kontakt.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true, imports: [AngularMaterial2Module, L10nTranslatePipe, FlexModule]

})
export class KontaktComponent extends Tabelle<Kontakt> {

	// rechte: Kernrecht[] = new Array<Kernrecht>();

	_selectsuche: string[] = new Array<string>();

	public filterCtl: FormControl = new FormControl();
	public selectCtl: FormControl = new FormControl();
	/** list of rechts filtered by search keyword */
	public filteredFragen: ReplaySubject<Frage[]> = new ReplaySubject<Frage[]>(1);
	maxSortierung: number = 1;

	  kategorieListe: Kategorie[] = Array<Kategorie>();
	  ladedatenKontakte: boolean = true;

	/** Subject that emits when the component has been destroyed. */
	private _onDestroy = new Subject<void>();

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public breadcrumbService: BreadcrumbService,
		public snackBar: MatSnackBar,
		public authService: AuthService,
		public apiConfigService: APIConfigService, public http: HttpClient,
		// public copyService: CopyService,// https://angular.io/guide/component-interaction#parent-and-children-communicate-via-a-service
	@Inject(L10N_LOCALE) public locale: L10nLocale,
	@Inject(L10N_CONFIG) private config: L10nConfig,
	public translation: L10nTranslationService,
		// public dragulaService: DragulaService,
		public dialog: MatDialog,
		public media: MediaObserver,
		public changeDetectorRef: ChangeDetectorRef,
		public sessService: SessionService,
		public title: Title,
		public _logger: LoggerService) {

		super( route, router, breadcrumbService, snackBar,
			authService, http, translation, dialog, media, changeDetectorRef,
			sessService, title, _logger, apiConfigService, {
				OBJ_LNG_NAME: OBJ_LNG_NAME,
				BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
				ROUTE_NAME: "/kontakt",
				PATH_FILE: PATH_FILE,
				DEFAULT_SORT_COLUMN: "",
				extraDataForAdding: { }
			}
		);

		this.displayedColumns = [
			'vorname', 'nachname',
			'funktion', 'email',
			'telefon', 'fax',
			'hofberater', 'kategorieBezeichnung',
			'admin',
		];

		this.title.setTitle(this.getTitle());

	}

	getTitle() {
	    return this.translation.translate('kontakt.title') + ' - ' + this.translation.translate('project.title');
	}

	extraInit() {
		this.getKategorien();
		super.extraInit();
	}

	public afterDataIsLoaded() {
	}

	createNewElement() {
		return new Kontakt();
	}

	loeschenSpalteName() {
		return "fullname";
	}

	getApiParams() {
		return "seite";
	}

	vorHinzufuegen(element) {
		element.kategorieListe = this.kategorieListe;
	}

	zeigeLoeschenMaske(element: any) {
		element.fullname = element.vorname + " " + element.nachname;
		this._zeigeLoeschenMaske(element, OaseDeleteDialogComponent);
	}

	zeigeHinzufuegenMaske() {
		this._zeigeHinzufuegenMaske(KontaktInsertEditComponent);
	}

	zeigeBearbeitenMaske(element) {

		element.kategorieListe = this.kategorieListe;

		this._zeigeBearbeitenMaske(element, KontaktInsertEditComponent);
	}

  private getKategorien() {
    this._logger.log(PATH_FILE + ' - getKategorien Begin');

    this.ladedatenKontakte = true;
    this.ladedaten = this.ladedatenKontakte;

    this.http
      .get<Kategorie[]>(this.apiConfigService.REST_API_BASE() + 'kategorie/liste/3')
      //  // Um mehrfachaufrufe zu verhindern
      .subscribe(
      data => {
        // this.authService.storeNewToken(data); // Das token mit dem vom Server neu gelieferten erneuern
        this.kategorieListe = data;
        this._logger.log(PATH_FILE + ' - getKategorien End');
        this.ladedatenKontakte = false;
        this.ladedaten = this.ladedatenKontakte;
      },
      err => {
        this.ladedatenKontakte = false;
        this.ladedaten = this.ladedatenKontakte;
        ErrorHelper.handleError(err,"Fehler beim holen der Kategorien",this._logger, this.translation)
      },
      () => {
        this.ladedatenKontakte = false;
        this.ladedaten = this.ladedatenKontakte;
        this._logger.log(PATH_FILE + ' - Holen der Kategorien abgeschlossen')
      }
      );
  } // getKategorien


}
